import { ITransactions } from "../types/transactions.types";

export const TRANSACTIONS_INITIAL_STATE: ITransactions = {
  transactions: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  superAgentInfo: null,
  subAgentInfo: null,
  loading: false,
  selectedTransaction: null,
};
